// extracted by mini-css-extract-plugin
module.exports = {"title":"widgets_title__WpD2H","icon":"widgets_icon__9km1X","card":"widgets_card__rUVfd"};